import { render, staticRenderFns } from "./AgencyList.vue?vue&type=template&id=87df121a&scoped=true&"
import script from "./AgencyList.vue?vue&type=script&lang=js&"
export * from "./AgencyList.vue?vue&type=script&lang=js&"
import style0 from "./AgencyList.vue?vue&type=style&index=0&id=87df121a&prod&lang=scss&scoped=true&"
import style1 from "./AgencyList.vue?vue&type=style&index=1&id=87df121a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87df121a",
  null
  
)

export default component.exports